import { storeToRefs } from 'pinia';
import { computed } from 'vue';

import { TEMP_PARTNER_VISIBILITY } from '@/constants/feature_flags';
import {
  useBillingStore,
  useFeatureFlagStore,
  usePartnersStore,
} from '@/stores';

import useAuth from './useAuth';

export function useEmptyStatePartner() {
  const { hasPermission } = useAuth();
  const { hasFeatureFlag } = useFeatureFlagStore();
  const { isEnterpriseTier } = storeToRefs(useBillingStore());
  const partnerStore = usePartnersStore();

  const { partnerOrgs, ready, running } = storeToRefs(partnerStore);

  const showEmptyStatePartner = computed(
    () =>
      ready.value &&
      !running.value &&
      partnerOrgs.value.length === 0 &&
      (hasFeatureFlag(TEMP_PARTNER_VISIBILITY) || isEnterpriseTier.value) &&
      !hasPermission('manage:partner-visibility'),
  );

  return { showEmptyStatePartner };
}
